var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck22Px = function SvgIconCheck22Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.293 14.707 7 12.413a1 1 0 0 1 1.414-1.415L10 12.585 14.585 8A1 1 0 0 1 16 9.414l-5.293 5.293a1 1 0 0 1-1.413 0Z",
    fill: "#A9DED7"
  })));
};
export default SvgIconCheck22Px;